/** Dev helper: `localStorage.setItem('todoes:debug:connectors', '1')` then reload. */
import { buildConnectorDebugRow } from '@/features/tasks/hooks/ui/connectorDebug.helpers';

export const CONNECTOR_DEBUG_KEY = 'todoes:debug:connectors';

export const isConnectorDebugEnabled = () =>
  typeof localStorage !== 'undefined' &&
  localStorage.getItem(CONNECTOR_DEBUG_KEY) === '1';

/**
 * @param {import('@/types').Task[]} tasks
 * @param {{
 *   indentationType: string,
 *   isExecutionView: boolean,
 *   view: string,
 *   listId?: string,
 *   listDisplayLevel: (task: import('@/types').Task) => number,
 *   isFirstSiblingInFlatList: typeof import('./use-task-hierarchy').isFirstSiblingInFlatList,
 *   isLastSiblingInFlatList: typeof import('./use-task-hierarchy').isLastSiblingInFlatList,
 * }} options
 */
export const dumpConnectorListDebug = (tasks, options) => {
  const {
    indentationType,
    isExecutionView,
    view,
    listId = 'unknown',
    listDisplayLevel,
    isFirstSiblingInFlatList,
    isLastSiblingInFlatList,
  } = options;

  const rows = (tasks ?? []).map((task, index) =>
    buildConnectorDebugRow(task, index, tasks, {
      indentationType,
      isExecutionView,
      listDisplayLevel,
      isFirstSiblingInFlatList,
      isLastSiblingInFlatList,
    }),
  );

  console.warn('[todoes:connectors]', {
    listId,
    view,
    indentationType,
    taskCount: tasks?.length ?? 0,
    isExecutionView,
    rows,
  });
};
